import { useState } from "react";
import { Input } from "@chakra-ui/input";
import { Box, Text } from "@chakra-ui/layout";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from "@chakra-ui/accordion";
import { Checkbox, Image, Button } from "@chakra-ui/react";
import angleRight from "common/assets/img/angleRight.png";
import angleDown from "common/assets/img/angleDown.png";
import { SearchIcon } from "@chakra-ui/icons";
import colors from "common/theme/foundations/colors";
import { constant } from "common/constant";

export default function FilterSidebar() {
  const [openItem, setOpenItem] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState(new Set()); 
 

  const FilterData = [
    {
      Id: 1,
      FilterTitle: "System defined filter",
      FilterItems: [
        { id: "touched", filterItemTitle: "Touched records" },
        { id: "untouched", filterItemTitle: "Untouched records" },
        { id: "related", filterItemTitle: "Related records action" },
        { id: "locked", filterItemTitle: "Locked" },
        { id: "sentiment", filterItemTitle: "Email sentiment" },
        { id: "email_status", filterItemTitle: "Latest email status" },
        { id: "activities", filterItemTitle: "Activities" },
        { id: "campaigns", filterItemTitle: "Campaigns" },
        { id: "cadences", filterItemTitle: "Cadences" },
      ],
    },
    {
      Id: 2,
      FilterTitle: "Filter by fields",
      FilterItems: [
        { id: "revenue", filterItemTitle: "Annual revenue" },
        { id: "city", filterItemTitle: "City" },
        { id: "company", filterItemTitle: "Company" },
        { id: "converted_acc", filterItemTitle: "Converted account" },
        { id: "converted_contact", filterItemTitle: "Converted contact" },
        { id: "converted_deal", filterItemTitle: "Converted deal" },
        { id: "country", filterItemTitle: "Country" },
        { id: "created_by", filterItemTitle: "Created by" },
        { id: "created_email", filterItemTitle: "Created email" },
        { id: "created_time", filterItemTitle: "Created time" },
        { id: "email", filterItemTitle: "Email" },
        { id: "email_output", filterItemTitle: "Email out put" },
      ],
    },
    {
      Id: 3,
      FilterTitle: "Filter by related modules",
      FilterItems: [
        { id: "call", filterItemTitle: "Call" },
        { id: "email_related", filterItemTitle: "Email" },
        { id: "invitees", filterItemTitle: "Invitees ( invited meeting)" },
        { id: "lead_product", filterItemTitle: "Lead product relation ( products)" },
        { id: "meetings", filterItemTitle: "Meetings" },
        { id: "notes", filterItemTitle: "Notes" },
        { id: "tasks", filterItemTitle: "Tasks" },
      ],
    },
  ];

  const handleCheckboxChange = (id) => {
    setSelectedFilters((prev) => {
      const updatedFilters = new Set(prev);
      if (updatedFilters.has(id)) {
        updatedFilters.delete(id);
      } else {
        updatedFilters.add(id);
      }
      return updatedFilters;
    });
  };

  return (
    <Box className="filterSidebarBox">
      <Box className="filterSidebar">
        <Box display={"flex"} flexDirection={"column"} height={"100%"}>
          <Box className="filterHeader">
            <Text className="filterTitle">{constant.filter}</Text>
            <Box className="filtersearch" position={"relative"} mt={"16px"}>
              <Input placeholder="Search" />            
              <SearchIcon  className="searchIcon" color={colors.iconDark} />
            </Box>
          </Box>
          <Box className="filterBody">
            <Accordion allowToggle>
              {FilterData.map((items) => (
                <AccordionItem key={items.Id} className="accordian-item">
                  {({ isExpanded }) => (
                    <>
                      <AccordionButton
                        className="accordion-title"
                        onClick={() =>
                          setOpenItem(isExpanded ? null : items.Id)
                        }
                      >
                        <Text className="accordion-title-text">
                          {items.FilterTitle}
                        </Text>
                        <Image
                          src={openItem === items.Id ? angleDown : angleRight}
                          height={"16px"}
                          width={"16px"}
                          ml="auto"
                        />
                      </AccordionButton>
                      <AccordionPanel p={"12px 2px 0px"}>
                        {items.FilterItems.map((filterItem) => (
                          <label key={filterItem.id} className="accordion-item-list">
                            <Checkbox
                              isChecked={selectedFilters.has(filterItem.id)}
                              onChange={() => handleCheckboxChange(filterItem.id)}
                            />
                            <Text className="item-list-title">
                              {filterItem.filterItemTitle}
                            </Text>
                          </label>
                        ))}
                      </AccordionPanel>
                    </>
                  )}
                </AccordionItem>
              ))}
            </Accordion>
          </Box>
        </Box>
        <Box className="filterFooter" px={"16px"}>
          <Button className="filterBtn" isDisabled={selectedFilters.size === 0}>
            {constant.applyFilterBtn}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
